module.exports = __webpack_public_path__ + "img/psw.1f795bb7.jpg";